import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { NomineeKYCService } from '@pages/NomineeKYCPage/services';

const MODULE_NAME = 'profile.machines.states.updatePayout';

const getSrv = () => {
  return vappContainer.get<NomineeKYCService>(NomineeKYCService.displayName);
};

export const updateBankDetail = async (context: any, event: any) => {
  const currentState = 'UPDATE_BANK_DETAIL';
  const method = 'updateBankDetail';

  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getUpdateBankDetail(event?.payload);
      if (content) {
        return resolve({
          key: 'UPDATE_BANK_DETAIL_SUCCESS',
          value: {
            ...(content || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(MODULE_NAME, `error in ${method}, msg: ${msg}`);
        return reject({
          key: 'UPDATE_BANK_DETAIL_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'UPDATE_BANK_DETAIL_FAILED',
        value: _msg,
      });
    }
  });
};
